import {Injectable} from "@angular/core";
import {
  BokkzMumaClient, BokkzMumaDataService,
  MumaEntity,
} from "@snelstart-ventures/fiscaal/domain-logic";

@Injectable({providedIn: 'root'})
export class BokkzMumaLogic {

  public mumaEntity = <MumaEntity[]>{};

  constructor(private bokkzClient: BokkzMumaClient,
              public dataService: BokkzMumaDataService,
  ) {
    //Hier zorgen we ervoor we ervoor dat we nieuwe data binnenkrijgen en stoppen deze in de variabelen.
    this.dataService.mumaList.subscribe((value) => (this.mumaEntity = value));
  }

  private getFromSessionStorage<T>(key: string): T | null {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }

  private getEntity() : MumaEntity {
    return this.getFromSessionStorage('mumaEntity') || <MumaEntity>{};
  }
}
